export const priceTypeEnum = {
  EX_FACTORY_PRICE: '出厂价',
  PRICE: '一口价',
  REAL_PRICE: '实价',
  RETAIL_PRICE: '零售价'
};

export const itemClacEnum = {
  DISCOUNT: '让利',
  NOT_DISCOUNT: '不让利'
};
